import { useCallback, useEffect, useState } from "react";
import { getSurveySummary } from "../api/survey.api";
import type { SurveySummaryData } from "../types/survey.types";

export const useGetSurveySummary = (id?: string) => {
  const [summaryData, setSummaryData] = useState<SurveySummaryData | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchSurveySummary = useCallback(async () => {
    if (!id) return null;

    try {
      setLoading(true);
      setError(null);
      const response = await getSurveySummary(id);

      if (!response?.success) {
        throw new Error(response?.user_message || response?.message || "Failed to fetch survey summary");
      }

      setSummaryData(response.data);
      return response.data;
    } catch (fetchError: any) {
      console.error("Failed to fetch survey summary:", fetchError);
      const errorMessage =
        fetchError.response?.data?.user_message ||
        fetchError.response?.data?.message ||
        fetchError.message ||
        "Failed to load survey responses";
      setError(errorMessage);
      setSummaryData(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    void fetchSurveySummary();
  }, [fetchSurveySummary]);

  return { summaryData, setSummaryData, loading, error, refresh: fetchSurveySummary };
};
